import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Label,
} from "reactstrap";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import ExportExcel from "../../reports/ExportExcel";
import RightIcon from "../../svg/RightIcon";
import LeftIcon from "../../svg/LeftButton";
import DateTimePicker from "react-datepicker";
import { useCallback, useEffect, useState } from "react";
import ApiService from "../../../services/apiService";
import { method } from "lodash";
import { format } from "date-fns";
import Table from "../../table/Table";
import GetSubChak from "./GetSubChak";
import exportWuaReportToExcel from "./WuaDistributionExcel";
import GetBeneficiaryData from "./GetBeneficiaryData";
import { toast } from "react-toastify";
import UploadIcon from "../../svg/UploadExcel";
import DownloadFileIcon from "../../svg/DownloadFile";

const WuaWaterDistribution = () => {
  const [fromDateTime, setFromDateTime] = useState<any>();
  const [toDateTime, setToDateTime] = useState<any>();
  const [chakLevelSummary, setChakLevelSummary] = useState<any[]>([]);

  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [fromDate, setFromDate] = useState<any>();
  const [toDate, setToDate] = useState<any>();
  const [wuas, setwuas] = useState<any>();
  const [selectedWuas, setselectedWuas] = useState<any>();
  const [wuaId, setWuaId] = useState();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const [selectedComponet, setSelectedComponent] = useState<string>("parent");

  let to = "";
  let from = "";
  const getChakLevelSummary = async () => {
   
    try {
      const response = await ApiService.axiosApi(`/chaklevelsummary`, {
        method: "GET",
        params: {
          pageNumber: pageNumber,
          pageSize: pageSize,
          fromDate:format(fromDateTime, "yyyy-MM-dd HH:mm:ss"),
          toDate: format(toDateTime, "yyyy-MM-dd HH:mm:ss"),
          wuaId: wuaId,
        },
      });
      if (response.success) {
        setChakLevelSummary(response.data.data);
        setTotalCount(response.data.totalCount);
      } else {
        console.log("unable to get ");
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getChakLevelSummary();
  }, [pageNumber, pageSize]);

  const totalPages = Math.ceil(totalCount / pageSize);

  const handleNext = useCallback(() => {
    setPageNumber((prev) => Math.min(totalPages, prev + 1));
  }, [setPageNumber, totalPages]);

  const handlePrev = useCallback(() => {
    setPageNumber((prev) => Math.max(1, prev - 1));
  }, [setPageNumber, totalPages]);

  const handleClick = () => {
    if (!validateGenerate()) return;
    if (fromDateTime) {
      from = format(fromDateTime, "yyyy-MM-dd HH:mm:ss");
      setFromDate(from);
    }
    if (toDateTime) {
      to = format(toDateTime, "yyyy-MM-dd HH:mm:ss");
      setToDate(to);
    }
    getChakLevelSummary();
  };

  const getWua = async () => {
    try {
      const response = await ApiService.axiosApi(`/wua`, {
        method: "GET",
        params: {
          pageNumber: 0,
          pageSize: 0,
        },
      });
      if (response.success) {
        setwuas(response.data.data);
      } else {
        console.log("unable to get scheme village");
      }
    } catch (e) {
      console.log("unable to get scheme village", e);
    }
  };

  useEffect(() => {
    getWua();
  }, []);

  const validateGenerate = () => {
    if (!selectedWuas) {
      toast.warning("Please select Wua ");
      return false;
    }
  
    
  
    if (!fromDateTime) {
      toast.warning("Please select From Date");
      return false;
    }
  
    if (!toDateTime) {
      toast.warning("Please select To Date");
      return false;
    }
  
    if (new Date(fromDateTime) > new Date(toDateTime)) {
      toast.warning("From Date cannot be greater than To Date");
      return false;
    }
  
    return true;
  };

  return (
    <>
      <Breadcrumbs mainTitle="WUA Water Distribution" parent="WUA Report" />
      <div className="w-100 bg-white px-2 py-2">
        <div
          className="bg-light-primary d-flex justify-content-between align-items-center gap-5"
          style={{
            width: "100%",
            height: "100px",
            border: "1px solid rgb(43, 94, 94, 0.1)",
          }}
        >
          <div className="d-flex justify-content-between" 
           style={{
             width:'60%'
           }}>
          <div className="mx-4  pb-2 d-flex flex-column" 
           style={{
             width:'25%'
           }}>
            <Label>WUAs:</Label>

            <Dropdown
              isOpen={dropdownOpen}
              toggle={toggleDropdown}
              style={{
                width:'100%'
              }}
            >
              <DropdownToggle
                className="custom-dropdown-toggle d-flex align-items-center justify-content-between report-dropdown"
                style={{
                 
                  fontWeight: 500,
                  borderRadius: "5px",
                  padding: "8px 16px",
                  width: "100%",
                  height: "36px",
                }}
                color="whitesmoke"
              >
                {selectedWuas ? selectedWuas : "WUA"}
              </DropdownToggle>

              <DropdownMenu
                className="custom-dropdown-menu"
                style={{
                  overflowY: "auto",
                  boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.1)",
                  borderRadius: "8px",
                  padding: "8px 0",
                  width:'50%'
                }}
              >
                {wuas?.map((data: any) => (
                  <DropdownItem
                    onClick={() => {
                      setWuaId(data.id);
                      setselectedWuas(data.headQuaterName);
                    }}
                    key={data.id}
                  >
                    {data.headQuaterName}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </div>

          <div className="mx-4  pb-2 d-flex flex-column "
           style={{
              width:'35%'
           }}>
            <Label>From Date:</Label>
            <DateTimePicker
              className="report-input"
              dateFormat="dd/MM/yyyy"
              placeholderText="DD-MM-YYYY"
            
              onChange={(date: any) => setFromDateTime(date)}
              selected={fromDateTime}
              isClearable
           
            />
          </div>

          <div className="report-input-div   input-border  d-flex flex-column "
           style={{
            width:'35%'
         }}>
            <Label>To Date:</Label>
            <DateTimePicker
              className="report-input"
              dateFormat="dd/MM/yyyy"
              placeholderText="DD-MM-YYYY"
          
              onChange={(date: any) => setToDateTime(date)}
              selected={toDateTime}
              isClearable
            
            />
          </div>
          </div>    
      

      <div className='d-flex justify-content-between' style={{
        width:"40%"
      }}>

          <div className=" d-flex flex-column" style={{
             width:"20%"
          }} >
            <Label style={{ visibility: "hidden" }}>Generate</Label>
            <Button className="px-0" style={{
                 width:'100%', whiteSpace: 'nowrap',
                 overflow: 'hidden',
                 textOverflow: 'ellipsis' 
            }} color="success" onClick={handleClick}>
              
                Generate
               
              
            </Button>
          </div>


          <div
            className="btn-group-distribution d-flex "
            role="group"
            aria-label="Component Selection"
            style={{
              width:"50%"
           }}
          >
            <div className='d-flex flex-column'
              style={{width:'30%'}}
            >
            <Label style={{ visibility: "hidden" }}>Generate</Label>
            <Button
            
              color={
                selectedComponet === "parent" ? "primary" : "outline-primary"
              }
              onClick={() => setSelectedComponent("parent")}
              style={{
                borderRadius: "8px 0 0 8px",
                fontWeight: 500,
                padding: "8px 16px",
                width:'100%',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis' 
              }}
            >
              Chak
            </Button>
            </div>

            <div className='d-flex flex-column' style={{width:'30%'}}>
            <Label style={{ visibility: "hidden" }}>Generate</Label>
            <Button
              color={
                selectedComponet === "Subchak" ? "primary" : "outline-primary"
              }
              onClick={() => setSelectedComponent("Subchak")}
              style={{
                fontWeight: 500,
                padding: "8px 16px",
                borderRadius: "0",
                borderLeft: "none",
                borderRight: "none",
                width:'100%',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis' 
              }}
            >
              SubChak
            </Button>
            </div>

            <div className='d-flex flex-column' style={{width:'40%'}} >
            <Label style={{ visibility: "hidden" }}>Generate</Label>
            <Button
              color={
                selectedComponet === "beneficiary"
                  ? "primary"
                  : "outline-primary"
              }
              onClick={() => setSelectedComponent("beneficiary")}
              style={{
                borderRadius: "0 8px 8px 0",
                fontWeight: 500,
                padding: "8px 16px",
                width:'100%',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis' 
              }}
            >
              Beneficiary
            </Button>
            </div>
          </div>

          <div className=" d-flex flex-column "style={{
             width:"20%",
            
          }}>
            <Label style={{ visibility: "hidden" }}>Generate</Label>
            <Button
              color="primary"
              style={{
                 width:'50%',
                 minWidth:'50px',
                
                 display:'flex',
                  alignItems:"center",
                  justifyContent:'center'
              }}
              onClick={() =>
                exportWuaReportToExcel({
                  fromDate: fromDate || "",
                  toDate: toDate || "",
                  wuaId: wuaId || 0,
                  wuaName: selectedWuas,
                })
              }
            >
              <div style={{
                  width:'20px',
                  height:'20px',
                  justifyContent:'center',
                  alignItems:'center'
              }}>
              <DownloadFileIcon/>
              </div>
            
            </Button>
          </div>
          
                  </div>   
        </div>

        <div className="mt-2">
          {selectedComponet == "parent" ? (
            <Table
              isAction={false}
              data={chakLevelSummary}
              columns={[
                { header: "Chak", accessor: "chakName" },
                {
                  header: "No Of 8HAC SubChak",
                  accessor: "no_Of_8HAC_SubChak",
                },
                { header: "Total Area(HA)", accessor: "chakArea" },
                {
                  header: "Total Water Distributed(m³)",
                  accessor: "totalWaterDistrubuted",
                },
              ]}
              buttons={[]}
            /> 
          ) : selectedComponet === "Subchak" ? (
            <GetSubChak Id={wuaId} />
          ) : selectedComponet == "beneficiary" ? (
            <GetBeneficiaryData Id={wuaId} />
          ) : (
            ""
          )}
          {(!chakLevelSummary || chakLevelSummary.length === 0) && (
    <div className="d-flex justify-content-center py-3 text-muted">
        No data available
    </div>
)}
          {selectedComponet == "parent" ? (
            <div
              className=" d-flex justify-content-end align-content-center"
              style={{ marginRight: "10px", marginTop: "10px" }}
            >
              <p style={{ marginRight: "10px", marginTop: "8px" }}>
                Page {pageNumber} of {totalPages}
              </p>
              <button
                onClick={handlePrev}
                disabled={pageNumber === 1}
                className={`icon-button ${
                  pageNumber === totalPages ? "disabled" : ""
                }`}
              >
                <LeftIcon className="icon" />
              </button>
              <button
                className={`icon-button ${
                  pageNumber === totalPages ? "disabled" : ""
                }`}
                onClick={handleNext}
                disabled={pageNumber === totalPages}
              >
                <RightIcon className="icon" />
              </button>
            </div>
          ) : (
            ""
          )}
        </div>
        
      </div>
    </>
  );
};
export default WuaWaterDistribution;
